import { Phone, Mail } from "lucide-react";
import { committeeMembers } from "../data";
import heroBg from "../assets/bg/bg-hero-6.webp";

const deptColors = {
  Governance: "#1B4332",
  Administration: "#2D6A4F",
  Finance: "#8B6914",
  Academics: "#7B5D00",
  Programmes: "#1E5C3A",
  Welfare: "#B91C1C",
  Legal: "#374151",
  Communications: "#4338CA",
};

const memberImages = [
  "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=600",
  "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=600",
  "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=600",
  "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=600",
  "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=600",
];

export default function Committee() {
  return (
    <div>
      {/* HERO */}
      <div
        className="page-hero"
        style={{
          backgroundImage: `linear-gradient(rgba(17,29,24,0.78), rgba(17,29,24,0.78)), url(${heroBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container">

<small
  style={{
    display: "inline-block",
    background: "#dc2626",
    color: "#fff",
    padding: "9px 18px",
    borderRadius: "30px",
    fontSize: "0.85rem",
    fontWeight: 800,
    letterSpacing: "0.5px",
    textTransform: "uppercase",
    boxShadow: "0 6px 20px rgba(220,38,38,0.45)",
    border: "2px solid rgba(255,255,255,0.4)",
    animation: "pulseRed 1.5s infinite",
  }}
>
  🚧 Page is Under Construction
</small>

          <h1
            className="display-lg"
            style={{
              color: "var(--gold-light)",
              marginBottom: "0.75rem",
            }}
          >
            Committee Members
          </h1>
          <p style={{ color: "rgba(255,255,255,.85)" }}>
            The dedicated individuals who volunteer their expertise, time, and heart to guide...
          </p>
        </div>
      </div>

      <div className="ribbon-divider" />

      <section className="section">
        <div className="container">
          {/* COMMITTEE CARDS */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "1.5rem",
              maxWidth: "950px",
              margin: "0 auto",
            }}
          >
            {committeeMembers.map((m, index) => (
              <div
                key={m.id}
                style={{
                  position: "relative",
                  display: "flex",
                  alignItems: "center",
                  gap: "1.5rem",
                  background: "#fff",
                  borderRadius: "25px",
                  padding: "1.5rem",
                  cursor: "pointer",
                  overflow: "hidden",
                  boxShadow: "0 12px 30px rgba(0,0,0,.08)",
                  border: "1px solid rgba(0,0,0,.06)",
                  transition: "0.3s",
                  flexWrap: "wrap",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-5px)";
                  e.currentTarget.style.boxShadow =
                    "0 18px 35px rgba(0,0,0,.12)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 12px 30px rgba(0,0,0,.08)";
                }}
              >
                {/* COLOR STRIP */}
                <div
                  style={{
                    position: "absolute",
                    left: 0,
                    top: 0,
                    bottom: 0,
                    width: "8px",
                    background: deptColors[m.department] || "#1B4332",
                  }}
                />

                {/* IMAGE */}
                <img
                  src={memberImages[index % memberImages.length]}
                  alt={m.name}
                  style={{
                    width: "120px",
                    height: "120px",
                    objectFit: "contain",
                    border: `5px solid ${
                      deptColors[m.department] || "#1B4332"
                    }`,
                    marginLeft: "15px",
                  }}
                />

                {/* CONTENT */}
                <div style={{ flex: 1 }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: "10px",
                      flexWrap: "wrap",
                    }}
                  >
                    <div>
                      <h3
                        style={{
                          margin: 0,
                          fontSize: "1.35rem",
                          fontWeight: 800,
                          color: "#1B4332",
                        }}
                      >
                        {m.name}
                      </h3>
                      <p
                        style={{
                          marginTop: "5px",
                          color: "#555",
                          fontWeight: 600,
                        }}
                      >
                        {m.role}
                      </p>
                    </div>
                  </div>

                  <p
                    style={{
                      marginTop: "1rem",
                      color: "#666",
                      lineHeight: 1.6,
                    }}
                  >
                    {m.bio}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}